import "./index.d"

const toObj: any = (sdkAttributes: SdkAttributes) => sdkAttributes.reduce((memo, f: FormAttribute) => {
    memo[f.key] = f
    return memo
}, {})

interface SdkAttributes extends Array<any> {
    [index: number]: FormAttribute
}

interface SdkAttribute {
    [index: string]: FormAttribute
}

export const sdkAndroidAttributes: SdkAttributes = [
    {
        key: "versionName",
        title: "SDK 版本号",
        contentExtra: `例如：1.0.0`,
    },
    {
        key: "versionTag",
        title: "版本标签",
        hideInList: true,
        type: 'select',
        rules: [],
        allowClear:true,
        options: [{
            value: '1',
            label: '稳定版'
        }, {
            value: '2',
            label: 'Beta版'
        }],
    },
    {
        key: "extra_info",
        title: '扩展字段',
        type: 'textarea',
        rules: [
            {
                validator: (rule: any, value: string) => {
                    if(!value || (value && value.trim() === '')) {
                        return Promise.resolve()
                    }
                    if (value.slice(0,1) === '{') {
                        try{
                            const valArr = Object.entries(JSON.parse(value))
                            
                            if(valArr.length === 0) {
                                return Promise.resolve()
                            }
                            let illegal = ''
                            const isLegal = valArr.every(ele => {
                                if (typeof ele[1] !== 'number' || typeof ele[1] !== 'string') {
                                    illegal = ele[0]
                                }
                                return (typeof ele[1] === 'number' || typeof ele[1] === 'string')
                            })
            
                            if (isLegal) {
                                return Promise.resolve()
                            } else {
                                return Promise.reject(`属性 ${illegal} 无效，不能设为一个数组或对象`)
                            }
                    
                        } catch (err){
                            return Promise.reject('参数必须符合json格式');
                        }
                    } else {
                        return Promise.reject('参数必须符合json格式');
                    }
                },
                trigger:['blur','change']
            }
        ],
    },
    {
        key: "manualUpdateTime",
        title: "更新日期",
        hideInList: true,
    },
    {
        key: "sdk_compile_size",
        title: 'SDK编译后大小',
        // type: 'textarea',
        hideInList: true,
        rules: [],
    },  
    {
        key: "sdk_size",
        title: "SDK 大小",
        rules: [],
    },
    {
        key: "sdk_md5",
        title: "MD5",
        rules: [],
    },
    {
        key: "versionDesc",
        title: "SDK 更新描述",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "versionDescEn",
        title: "SDK 更新描述(英文)",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "precautions",
        title: "SDK 注意事项",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "precautionsEn",
        title: "SDK 注意事项(英文)",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "tag",
        title: "Git Tag",
        hideInList: true,
        placeholder: 'Git 项目 tag 标签'
    },
    {
        key: "isAndroidX",
        title: "是否为AndroidX",
        type: 'radio',
        values: [{
            key: '1',
            title: '是'
        }, {
            key: '0',
            title: '否'
        }],
    },
    // {
    //     key: "demoUrl",
    //     title: "demo的url地址",
    //     hideInList: true,
    //     type: 'textarea',
    // },
    {
        key: "repositories",
        title: "仓库信息",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "dependencies",
        title: "依赖配置",
        hideInList: true,
        type: 'textarea',
    },
    {
        key: "nogradleDependencies",
        title: "非Gradle依赖配置",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "obfuscatedConfig",
        title: "混淆配置",
        hideInList: true,
        type: 'textarea',
        rules: [], // rules 写空[] 覆盖默认必填
    },
    // {
    //     key: "unityFilePath",
    //     title: "Unity桥接文件的路径",
    //     hideInList: true,
    //     type: 'textarea',
    // },
    {
        key: "enabled",
        title: "发布状态",
        type: 'radio',
        defaultValue: '0',
        values: [{
            key: '1',
            title: '已发布',
        }, {
            key: '0',
            title: '未发布',
        }],
    },
    {
        key: "sdk_is_cn",
        title: "在中国地区隐藏",
        type: 'radio',
        defaultValue: '0',
        values: [
            {
                key: '1',
                title: '是'
            },
            {
                key: '0',
                title: '否'
            }
        ]
    }
]
export const sdkAndroidAttribute: SdkAttribute = toObj(sdkAndroidAttributes)


export const sdkIosAttributes: SdkAttributes = [
    {
        key: "versionName",
        title: "SDK版本号",
        contentExtra: `例如：1.0.0`,
    },
    {
        key: "podversionName",
        title: "pod版本号",
        contentExtra: `不填，则默认取值 SDK 版本号`,
        rules: [],
    },
    {
        key: "versionTag",
        title: "版本标签",
        hideInList: true,
        type: 'select',
        rules: [],
        allowClear:true,
        options: [{
            value: '1',
            label: '稳定版'
        }, {
            value: '2',
            label: 'Beta版'
        }],
    },
    {
        key: "extra_info",
        title: '扩展字段',
        type: 'textarea',
        rules: [
            {
                validator: (rule: any, value: string)=>{
                    if(!value || (value && value.trim() === '')) {
                        return Promise.resolve()
                    }
                    
                    if (value.slice(0,1) === '{') {
                        try{
                            const valArr = Object.entries(JSON.parse(value))
                            if(valArr.length === 0) {
                                return Promise.resolve()
                            }
                            let illegal = ''
                            const isLegal = valArr.every(ele => {
                                if (typeof ele[1] !== 'number' || typeof ele[1] !== 'string') {
                                    illegal = ele[0]
                                }
                                return (typeof ele[1] === 'number' || typeof ele[1] === 'string')
                            })
            
                            if (isLegal) {
                                return Promise.resolve()
                            } else {
                                return Promise.reject(`属性 ${illegal} 无效，不能设为一个数组或对象`)
                            }
                    
                        } catch (err){
                            return Promise.reject('参数必须符合json格式');
                        }
                    } else {
                        return Promise.reject('参数必须符合json格式');
                    }
                },
                trigger:['blur','change']
            }
        ],
    },
    {
        key: "manualUpdateTime",
        title: "更新日期",
        hideInList: true,
    },
    {
        key: "sdk_compile_size",
        title: 'SDK编译后大小',
        // type: 'textarea',
        hideInList: true,
        rules: [],
    }, 
    {
        key: "versionDesc",
        title: "SDK更新描述",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "versionDescEn",
        title: "SDK更新描述(英文)",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "precautions",
        title: "SDK 注意事项",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "precautionsEn",
        title: "SDK 注意事项(英文)",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: "tag",
        title: "Git Tag",
        hideInList: true,
        placeholder: 'Git 项目 tag 标签'
    },
    // {
    //     key: "demoUrl",
    //     title: "demo地址",
    //     hideInList: true,
    //     type: 'textarea',
    // },
    // {
    //     key: "unityFilePath",
    //     title: "Unity桥接文件",
    //     hideInList: true,
    //     type: 'textarea',
    // },
    {
        key: "enabled",
        title: "发布状态",
        type: 'radio',
        values: [{
            key: '1',
            title: '已发布'
        }, {
            key: '0',
            title: '未发布'
        }],
    }
]
export const sdkIosAttribute: SdkAttribute = toObj(sdkIosAttributes)